import Component from '../../../../../pages/vip/features/third_party_second_section/index';

export default Component;
